import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67adc6fa&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67adc6fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67adc6fa')) {
      api.createRecord('67adc6fa', component.options)
    } else {
      api.reload('67adc6fa', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67adc6fa&scoped=true&", function () {
      api.rerender('67adc6fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Price/FrightSurCharge/index.vue"
export default component.exports